import React from 'react';
import { Footer } from '../Common/Footer';
import { Header } from '../Common';
import ProductsUpload from '../../Models/ProductsUpload';
import Products from '../../Models/Products';
import { connect } from 'react-redux';
import { AffiliatorRequest } from '../../Action/AffiliatorRequest';

import { withRouter } from 'react-router-dom';
import SimpleReactValidator from 'simple-react-validator';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
class AffiliatorPostRequestBuyer extends React.Component {
    constructor(props) {
        super(props);
        let x = JSON.parse(localStorage.getItem('info'))
        if (x === null || x === '' || x.user_type_id !== 3) {
            alert('ログインしてください')
            window.location.href = '/login/affiliator';
        };
        this.state = {
            _id: false,
            title: '',
            description: '',
            category: 258,
            subCategory: 259,
            date: '',
            budget: '',
            categoryName: '',
            budgetName: '',
            subCategoryName: '',
            categories: [],
            subCategories: [],
            budget: [],
            budgets: [],
        };
        SimpleReactValidator.addLocale('klingon', {
            integer: '数字を入れてください.',
            max: ':attribute :max 文字以下にしてください .',
            required: ' :attribute を必須です.',
            min: ':attribute :min 文字以上にしてください .',
        });
        this.validator = new SimpleReactValidator({
            locale: 'klingon',
        })
        this.getCategories();
        this.getBudgetList();
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }

    handleChange(e) {
        this.setState({ category: this.refs.category.value })
        ProductsUpload.getSubCategory(e.target.value).then(res => {
            this.setState({
                subCategories: res.data.category_sub
            })
        })
    }
    updateValue(type, e) {
        var obj = {};
        obj[type] = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        this.setState(obj);
    }
    getBudgetList() {
        Products.getBudget().then(res => {
            this.setState({ budgets: res.data.message })
        })
    }
    getCategories() {
        ProductsUpload.getCategoryDropdown().then(res => {
            this.setState({ categories: res.data.categories })
        })
    }
    handleSubmit(e) {
        document.getElementById("req_entry").disabled = true;
        e.preventDefault();
        var logged_user = JSON.parse(window.localStorage.getItem('info'));
        if (this.validator.allValid()) {
            let data = {
                buyer_id: logged_user.id,
                title: this.state.title,
                application_date: this.state.date,
                content: this.state.description,
                // category: this.refs.category.value,
                // sub_category: this.refs.subCategory.value,
                category: 258,
                sub_category: 259,
                budget: this.refs.budget.value,
            }
            this.props.AffiliatorRequest(data, this.props.history);
        } else {
            this.validator.showMessages();
        }
    }
    toggle() {
        this.setState(prevState => ({
            modal: !prevState.modal
        }));
    }

    toggleAll() {
        this.setState({
            modal: false
        });
    }

    updateChange(e) {
        this.setState({
            budget: e.target.value
        })
    }
    handleClick() {
        if (this.validator.allValid()) {
            let data = {
                category: this.refs.category.value,
                subcategory: this.refs.subCategory.value,
                budget: this.refs.budget.value,
            }
            Products.getNames(data).then(res => {
                this.setState({
                    budgetName: res.data.budget,
                    categoryName: res.data.cat,
                    subCategoryName: res.data.sub_cat
                })
            })
            this.toggle()
        } else {
            this.validator.showMessages();
        }
    }
    postConfirmation() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        if (isMobile) {
            return (
                <div className="" style={{fontSize:'13px'}}>
                    <Button color="" className=" agree_button" onClick={this.handleClick.bind(this)}
                        style={{
                            fontSize: "16px",
                            lineHeight: "45px",
                            width: "270px",
                            padding: "2%",
                            height: "auto",
                            color: "#fff",
                            backgroundColor: "#7ea9e6",
                            borderColor: "#6290d1",
                            boxShadow: "inset 0 1px 0 hsla(0, 0%, 100%, .3)",
                            borderRadius: "9px"
                        }}>リクエスト内容を確認する</Button>
                    <Modal isOpen={this.state.modal} toggle={this.toggle.bind(this)} className="modal-lg" >
                        <ModalHeader toggle={this.toggle.bind(this)}>リクエスト内容確認</ModalHeader>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                        </button>
                        <ModalBody style={{fontSize:'13px'}}>
                            <form>
                                <div>
                                    <div>&nbsp;</div>
                                    <div className="container">
                                        <div className="row" style={{display: "none"}}>
                                            <div className="col-4 pr-0"> カテゴリー  :</div>
                                            <div className="col-8" >
                                                {this.state.categoryName}
                                            </div>
                                        </div>
                                        <div className="row" style={{display: "none"}}>
                                            <div className="col-4 pr-0"> 小カテゴリー  :</div>
                                            <div className="col-8" >
                                                {this.state.subCategoryName}
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-4 pr-0"> タイトル  :</div>
                                            <div className="col-8" >
                                                {this.state.title}
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-4 pr-0"> リクエスト内容  :</div>
                                            <div className="col-8" >
                                                <div className="">
                                                    {this.state.description.split('\n').map(function (item, key) {
                                                        return (
                                                            <span key={key}>
                                                                {item}
                                                                <br />
                                                            </span>
                                                        )
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-4 pr-0"> 募集期限  :</div>
                                            <div className="col-8" >
                                                {this.state.date}
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-4 pr-0"> 予算目安  :</div>
                                            <div className="col-8" >
                                                {this.state.budgetName}
                                            </div>
                                        </div>
                                    </div>
                                    <div>&nbsp;</div>
                                </div>
                                <div>&nbsp;</div>
                            </form>
                        </ModalBody>
                        <ModalFooter>
                            <Button color="secondary" data-dismiss="modal" onClick={this.toggle.bind(this)} style={{ borderRadius: "4px", border: "1px solid gray", backgroundColor: "white", color: "black", padding: "1%" }}>キャンセル</Button>
                            <Button id="req_entry" onClick={this.handleSubmit.bind(this)} style={{ borderRadius: "4px", border: "1px solid", backgroundColor: "#1eb2ef", color: "white", padding: "1%" }}> 送信する
                    </Button>
                        </ModalFooter>
                    </Modal>
                </div>
            )
        }
        //for desktop view
        else if (isDesktop) {
            return (
                <div className="">
                    <Button color="" className=" agree_button" onClick={this.handleClick.bind(this)}
                        style={{
                            fontSize: "16px",
                            lineHeight: "45px",
                            width: "270px",
                            padding: "2%",
                            height: "auto",
                            color: "#fff",
                            backgroundColor: "#7ea9e6",
                            borderColor: "#6290d1",
                            boxShadow: "inset 0 1px 0 hsla(0, 0%, 100%, .3)",
                            borderRadius: "9px"
                        }}>リクエスト内容を確認する</Button>
                    <Modal isOpen={this.state.modal} toggle={this.toggle.bind(this)} className="modal-lg" >
                        <ModalHeader toggle={this.toggle.bind(this)}>リクエスト内容確認</ModalHeader>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                        </button>
                        <ModalBody>
                            <form>
                                <fieldset style={{ border: "1px solid #008dc7" }}>
                                    <div>&nbsp;</div>
                                    <div className="container">
                                        <div className="row" style={{display: "none"}}>
                                            <div className="col-md-3 common_text_bold"> カテゴリー </div>
                                            <div className="col-md-1">:</div>
                                            <div className="col-md-8" >
                                                {this.state.categoryName}
                                            </div>
                                        </div>
                                        <div className="row" style={{display: "none"}}>
                                            <div className="col-md-3 common_text_bold"> 小カテゴリー </div>
                                            <div className="col-md-1">:</div>
                                            <div className="col-md-8" >
                                                {this.state.subCategoryName}
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3 common_text_bold"> タイトル </div>
                                            <div className="col-md-1">:</div>
                                            <div className="col-md-8" >
                                                {this.state.title}
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3 common_text_bold"> リクエスト内容 </div>
                                            <div className="col-md-1">:</div>
                                            <div className="col-md-8" >
                                                <div className="">
                                                    {this.state.description.split('\n').map(function (item, key) {
                                                        return (
                                                            <span key={key}>
                                                                {item}
                                                                <br />
                                                            </span>
                                                        )
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3 common_text_bold"> 募集期限 </div>
                                            <div className="col-md-1">:</div>
                                            <div className="col-md-8" >
                                                {this.state.date}
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3 common_text_bold"> 予算目安 </div>
                                            <div className="col-md-1">:</div>
                                            <div className="col-md-8" >
                                                {this.state.budgetName}
                                            </div>
                                        </div>
                                    </div>
                                    <div>&nbsp;</div>
                                </fieldset>
                                <div>&nbsp;</div>
                            </form>
                        </ModalBody>
                        <ModalFooter>
                            <Button color="secondary" data-dismiss="modal" onClick={this.toggle.bind(this)} style={{ borderRadius: "4px", border: "1px solid gray", backgroundColor: "white", color: "black", padding: "1%" }}>キャンセル</Button>
                            <Button id="req_entry" onClick={this.handleSubmit.bind(this)} style={{ borderRadius: "4px", border: "1px solid", backgroundColor: "#1eb2ef", color: "white", padding: "1%" }}> 送信する
                        </Button>
                        </ModalFooter>
                    </Modal>
                </div>
            )
        }
    }
    render() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        if (isMobile) {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-2"></div>
                            <div className="col-md-8">
                                <div className="">
                                    <div style={{ textAlign: "left", fontSize: "20px", borderBottom: "1px solid #ccd0c9" }}>
                                        リクエストを入力
                                    </div>
                                    <div className="container">
                                        <form >
                                            <div className="form-group" style={{ marginBottom: '10px', marginTop: '10px' }}>
                                                <label htmlFor="email" style={{ marginBottom: '0px', display: "none" }}><span className="request_fonts mr-4"><b>カテゴリー</b></span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style={{ color: 'red', fontSize: '12px' }}>*必須</span></label>
                                                <div className="row">
                                                    <div className="col-md-7"  style={{display: "none"}}>
                                                        <select className="catagory_select" ref="category" onChange={this.handleChange.bind(this)}>
                                                            <option>選択してください </option>
                                                            {this.state.categories.map(cat =>
                                                                <option value={cat.id} key={cat.id} >
                                                                    {cat.cat_name}
                                                                </option>
                                                            )}
                                                        </select>
                                                        <span style={{ color: "red", fontSize: "12px" }}>
                                                            {this.validator.message('カテゴリー', this.state.category, 'required')}
                                                        </span>
                                                    </div>

                                                    <div className="col-md-4" style={{ marginTop: '10px', display: "none" }} >
                                                        <label htmlFor="email" style={{ marginBottom: '0rem' }}><span className="request_fonts mt-2 desktop_categories_between_icon"><b>サブカテゴリー</b></span><span style={{ color: "red", fontSize: "11px" }}>*必須</span></label>  <select className="catagory_select" ref="subCategory">
                                                            <option value="">選択してください </option>
                                                            {this.state.subCategories.map(rp =>
                                                                // console.log(rp.cat_name)
                                                                <option value={rp.id} key={rp.id}>
                                                                    {rp.cat_name}
                                                                </option>
                                                            )}
                                                        </select>
                                                        <span style={{ color: "red", fontSize: "12px" }}>
                                                            {this.validator.message('サブカテゴリー', this.state.subCategory, 'required')}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="pwd" style={{ marginBottom: '0px' }}><span className="request_fonts mr-5"><b>タイトル</b></span>&nbsp;&nbsp;&nbsp;<span style={{ color: 'red', fontSize: '12px' }}>*必須</span></label>
                                                <input type="text" className="catagory_select" id="title" placeholder="" value={this.state.title} onChange={this.updateValue.bind(this, 'title')} onBlur={() => this.validator.showMessageFor('タイトル')} />
                                                <span style={{ color: "red", fontSize: "12px" }}>
                                                    {this.validator.message('タイトル', this.state.title, 'required')}
                                                </span>
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="pwd" style={{ marginBottom: '0px' }} ><span className="request_fonts mr-4"><b>リクエスト内容</b></span><span style={{ color: 'red', fontSize: '12px' }}>*必須</span></label>
                                                <textarea className="form-control " rows="7" id="descrition" placeholder="" value={this.state.description} onChange={this.updateValue.bind(this, 'description')} onBlur={() => this.validator.showMessageFor('リクエスト内容')}></textarea>
                                                <span style={{ color: "red", fontSize: "12px" }}>
                                                    {this.validator.message('リクエスト内容', this.state.description, 'required')}
                                                </span>
                                            </div>
                                            <div>
                                                <div className="row mb-3">
                                                    <div className="col-md-4">
                                                        <span><b>募集期限</b></span><span style={{ color: "red", fontSize: "11px", marginLeft: '62px' }}>*必須</span>
                                                    </div>
                                                    <div className="col-md-8">
                                                        <input type="date" className="catagory_select" id="date" placeholder="Date" value={this.state.date} onChange={this.updateValue.bind(this, 'date')} />
                                                        <span style={{ color: "red", fontSize: "12px" }}>
                                                            {this.validator.message('募集期限', this.state.date, 'required')}
                                                        </span>
                                                    </div>
                                                    <div className="col-md-2"></div>
                                                </div>
                                                <div className="row mb-3">
                                                    <div className="col-md-4">
                                                        <span><b>予算目安</b></span><span style={{ color: "red", fontSize: "11px", marginLeft: '62px' }}>*必須</span>
                                                    </div>
                                                    <div className="col-md-8">
                                                        <select
                                                            className="catagory_select"
                                                            onChange={this.updateChange.bind(this)}
                                                            value={this.state.budget}
                                                            style={{ height: "40px" }}
                                                            ref="budget"
                                                        >
                                                            <option value=''>選択してください</option>
                                                            {this.state.budgets.map(rp =>
                                                                <option value={rp.id} key={rp.budget_range}>
                                                                    {rp.budget_range}
                                                                </option>
                                                            )}
                                                        </select>
                                                        <span style={{ color: "red", fontSize: "12px" }}>
                                                            {this.validator.message('予算目安', this.state.budget, 'required')}
                                                        </span>
                                                    </div>
                                                    <div className="col-md-2"></div>
                                                </div>
                                                <div className="button_div">
                                                    {this.postConfirmation()}
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            )
        }
        //for desktop view
        else if (isDesktop) {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="container-fluid">
                        <div className="container">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-2"></div>
                                    <div className="col-md-8">
                                        <div className="">
                                            <div className="ml-5 mr-5" style={{ textAlign: "left", fontSize: "24px", borderBottom: "1px solid #ccd0c9" }}>
                                                リクエストを入力
                                            </div>
                                            <div className="mini_padding">
                                                <div className="mini_padding inner-div">
                                                    <div className="container">
                                                        <form >
                                                            <div className="form-group">
                                                                <label htmlFor="email"  style={{display: "none"}}><span className="request_fonts mr-4"><b>カテゴリー</b></span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style={{ color: 'red', fontSize: '12px' }}>*必須</span></label>
                                                                <div className="row">
                                                                    <div className="col-md-7"  style={{display: "none"}}>
                                                                        <select className="catagory_select" ref="category" onChange={this.handleChange.bind(this)}>
                                                                            <option>選択してください </option>
                                                                            {this.state.categories.map(cat =>
                                                                                <option value={cat.id} key={cat.id} >
                                                                                    {cat.cat_name}
                                                                                </option>
                                                                            )}
                                                                        </select>
                                                                        <span style={{ color: "red", fontSize: "12px" }}>
                                                                            {this.validator.message('カテゴリー', this.state.category, 'required')}
                                                                        </span>
                                                                    </div>
                                                                    <div className="col-md-1"  style={{display: "none"}}>
                                                                        <i className="fa fa-angle-right"></i>
                                                                    </div>
                                                                    <div className="col-md-4"  style={{display: "none"}}>
                                                                        <select className="catagory_select" ref="subCategory">
                                                                            <option value="">選択してください </option>
                                                                            {this.state.subCategories.map(rp =>
                                                                                // console.log(rp.cat_name)
                                                                                <option value={rp.id} key={rp.id}>
                                                                                    {rp.cat_name}
                                                                                </option>
                                                                            )}
                                                                        </select>
                                                                        <span style={{ color: "red", fontSize: "12px" }}>
                                                                            {this.validator.message('サブカテゴリー', this.state.subCategory, 'required')}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div>&nbsp;</div>
                                                            <div className="form-group">
                                                                <label htmlFor="pwd"><span className="request_fonts mr-5"><b>タイトル</b></span>&nbsp;&nbsp;&nbsp;<span style={{ color: 'red', fontSize: '12px' }}>*必須</span></label>
                                                                <input type="text" className="catagory_select" id="title" placeholder="" value={this.state.title} onChange={this.updateValue.bind(this, 'title')} onBlur={() => this.validator.showMessageFor('タイトル')} />
                                                                <span style={{ color: "red", fontSize: "12px" }}>
                                                                    {this.validator.message('タイトル', this.state.title, 'required')}
                                                                </span>
                                                            </div>
                                                            <div>&nbsp;</div>
                                                            <div className="form-group">
                                                                <label htmlFor="pwd"><span className="request_fonts mr-4"><b>リクエスト内容</b></span><span style={{ color: 'red', fontSize: '12px' }}>*必須</span></label>
                                                                <textarea className="form-control " rows="7" id="descrition" placeholder="" value={this.state.description} onChange={this.updateValue.bind(this, 'description')} onBlur={() => this.validator.showMessageFor('リクエスト内容')}></textarea>
                                                                <span style={{ color: "red", fontSize: "12px" }}>
                                                                    {this.validator.message('リクエスト内容', this.state.description, 'required')}
                                                                </span>
                                                            </div>
                                                            <div>
                                                                <div className="row mb-3">
                                                                    <div className="col-md-4">
                                                                        <span><b>募集期限</b></span><span style={{ color: "red", fontSize: "11px", marginLeft: '62px' }}>*必須</span>
                                                                    </div>
                                                                    <div className="col-md-8">
                                                                        <input type="date" className="catagory_select" id="date" placeholder="Date" value={this.state.date} onChange={this.updateValue.bind(this, 'date')} />
                                                                        <span style={{ color: "red", fontSize: "12px" }}>
                                                                            {this.validator.message('募集期限', this.state.date, 'required')}
                                                                        </span>
                                                                    </div>
                                                                    <div className="col-md-2"></div>
                                                                </div>
                                                                <div className="row mb-3">
                                                                    <div className="col-md-4">
                                                                        <span><b>予算目安</b></span><span style={{ color: "red", fontSize: "11px", marginLeft: '62px' }}>*必須</span>
                                                                    </div>
                                                                    <div className="col-md-8">
                                                                        <select
                                                                            className="catagory_select"
                                                                            onChange={this.updateChange.bind(this)}
                                                                            value={this.state.budget}
                                                                            style={{ height: "40px" }}
                                                                            ref="budget"
                                                                        >
                                                                            <option value=''>選択してください</option>
                                                                            {this.state.budgets.map(rp =>
                                                                                <option value={rp.id} key={rp.budget_range}>
                                                                                    {rp.budget_range}
                                                                                </option>
                                                                            )}
                                                                        </select>
                                                                        <span style={{ color: "red", fontSize: "12px" }}>
                                                                            {this.validator.message('予算目安', this.state.budgets, 'required')}
                                                                        </span>
                                                                    </div>
                                                                    <div className="col-md-2"></div>
                                                                </div>
                                                                <div className="button_div">
                                                                    {this.postConfirmation()}
                                                                </div>
                                                            </div>
                                                        </form>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-2">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            )
        }
    }
}
const mapStateToProps = (state) => ({
    AffiliatorRequest: state.AffiliatorRequest,
    errors: state.errors,
});
AffiliatorPostRequestBuyer = connect(mapStateToProps, { AffiliatorRequest })(withRouter(AffiliatorPostRequestBuyer));
export { AffiliatorPostRequestBuyer }